import React from 'react';
import Router from './containers/Router';
import AppContextProvider from './context/AppContext';

export default class App extends React.Component {

    render() {
        return (
            <AppContextProvider>
                <Router/>
            </AppContextProvider>
        );
    }
}



// WEBPACK FOOTER //
// ./src/App.js